module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('beautiful-chat', {
    attrs: {
      "participants": _vm.participants,
      "title": _vm.currentGameRoom,
      "titleImageUrl": _vm.titleImageUrl,
      "onMessageWasSent": _vm.onMessageWasSent,
      "messageList": _vm.messageList,
      "newMessagesCount": _vm.newMessagesCount,
      "isOpen": _vm.isChatOpen,
      "close": _vm.closeChat,
      "open": _vm.openChat,
      "showEmoji": true,
      "showFile": false,
      "showTypingIndicator": _vm.showTypingIndicator,
      "colors": _vm.colors,
      "alwaysScrollToBottom": _vm.alwaysScrollToBottom,
      "messageStyling": _vm.messageStyling,
      "placeholder": "Ecrivez votre message"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55a6fa7e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat.vue
// module id = nFJq
// module chunks = 1